import { compact, intersection, isEmpty, map, sortBy } from 'lodash/fp';
import { PRODUCT_TYPE } from '@ahmdigital/constants';

import { DataByProductType } from '../../types';
import { ProductType } from '../../../../../../types/product';
import getSaleableCombinedProductIds from '../../../../../../utils/get-saleable-combined-product-ids';
import getSaleableProductIds from '../../../../../../utils/get-saleable-product-ids';

const getProductSectionProps = ({
  dataByProductType,
  productType,
  products,
  scale,
}: {
  dataByProductType: DataByProductType;
  productType: string;
  products: {
    [productId: string]: ProductType;
  };
  scale: string;
}) => {
  if (isEmpty(dataByProductType) || isEmpty(products)) {
    return {
      compareButtonText: null,
      compareButtonToLink: null,
      products: [],
    };
  }
  const eligibleProductIds = dataByProductType[productType]?.[scale];

  const ctaLink = dataByProductType[productType]?.ctaLink;
  const ctaText = dataByProductType[productType]?.ctaText;

  let mappedProducts;
  if (productType === PRODUCT_TYPE.COMBINED) {
    const saleableEligibleCombinedProductIds = intersection(eligibleProductIds, getSaleableCombinedProductIds());
    mappedProducts = map((eligibleProductId) => {
      const eligibleProduct = products?.[eligibleProductId];
      return eligibleProduct;
    }, saleableEligibleCombinedProductIds);
  } else {
    const saleableEligibleProductIds = intersection(eligibleProductIds, getSaleableProductIds());
    mappedProducts = map((eligibleProductId) => products?.[eligibleProductId], saleableEligibleProductIds);
  }

  return {
    compareButtonText: ctaText,
    compareButtonToLink: ctaLink,
    products: compact(sortBy('rank', mappedProducts)),
  };
};

export default getProductSectionProps;
